import { Component, OnInit, ViewChild, Inject, PLATFORM_ID  } from '@angular/core';
import { RouterLink }          from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { Gallery, GalleryRef, GalleryItem, GalleryComponent, ImageItem, YoutubeItem } from '@ngx-gallery/core';
import { map } from 'rxjs/operators';
import { Lightbox } from '@ngx-gallery/lightbox';


@Component({
    selector: 'concept-art',
    templateUrl: './concept-art.component.html'
})
export class ConceptArtComponent implements OnInit {

    items: GalleryItem[] = [];
    constructor(public gallery: Gallery, @Inject(PLATFORM_ID) private platform: any, public lightbox: Lightbox) {
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platform)) {

            this.items = [
                new ImageItem({src: 'assets/units/dwarfs/dwarf1.jpg', thumb: 'assets/units/dwarfs/dwarf1_thumb.jpg'}),
                new ImageItem({src: 'assets/units/elves/elves1.jpg', thumb: 'assets/units/elves/elves1_thumb.jpg'}),
                new ImageItem({src: 'assets/units/dwarfs/dwarf2.jpg', thumb: 'assets/units/dwarfs/dwarf2_thumb.jpg'}),
                new ImageItem({src: 'assets/units/dwarfs/dwarf3.jpg', thumb: 'assets/units/dwarfs/dwarf3_thumb.jpg'}),
                new ImageItem({src: 'assets/units/elves/elves2.jpg', thumb: 'assets/units/elves/elves2_thumb.jpg'}),
                new ImageItem({src: 'assets/units/elves/elves5.jpg', thumb: 'assets/units/elves/elves5_thumb.jpg'}),
                new ImageItem({src: 'assets/units/dwarfs/dwarf4.jpg', thumb: 'assets/units/dwarfs/dwarf4_thumb.jpg'}),
            ];

            const lightboxGalleryRef = this.gallery.ref('conceptLightbox');
            lightboxGalleryRef.setConfig({loadingStrategy: 'lazy', loadingMode: 'indeterminate'});
            lightboxGalleryRef.load(this.items);

        }
    }

    openLightBox(index) {
        this.lightbox.open(index, 'conceptLightbox');
    }
}